<template>
    <div v-if="imageType === 'div'" :class="imageClasses + ' framed-blurred-image' ">
        <div class="blur" :style="{backgroundImage: 'url(' + imageUrl + ')'}"></div>
        <div class="inner">
            <img :alt="alt" loading="lazy" :src="imageUrl">
        </div>
    </div>
    <img v-else :src="imageUrl" :alt="alt" :class="imageClasses">
</template>

<script>
export default {
    props: {
        image: {
            type: Object
        },
        // should be either 'div' or 'img'
        imageType: {
            type: String,
            default: 'img'
        },
        imageClasses: {
            type: String,
            default: ''
        },
        alt: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            imageSize: 'small'
        }
    },
    computed: {
        imageUrl() {
            return this.image[this.imageSize].url || this.image[this.imageSize];
        }
    },
    beforeMount(){
        this.getImageSize();
    },
    mounted() {
        window.addEventListener('resize', this.getImageSize, false);
    },
    methods: {
        getImageSize() {
            if(window.innerWidth <= 383) {
                this.imageSize = 'small';
            } else if(window.innerWidth <= 540) {
                this.imageSize = 'medium';
            } else if(window.innerWidth <= 1200) {
                this.imageSize = 'large';
            } else if(window.innerWidth > 1200 && window.innerWidth <= 1920) {
                this.imageSize = 'hd';
            } else {
                this.imageSize = 'original';
            }
        }
    }
};

</script>
